module.exports = __webpack_public_path__ + "static/leaves-9e871e8b8bbbd7032ccad6ed8f3954f3.png";